
import { Axios } from "../hooks/useAxiosInstance";

export const PostReport = (function () {

    // const { api_token } = useSelector(state => state.profile);

    const apis = () => ({
        fetch: async ({ api_token }) => await fetchRecord(api_token),
        delete: async ({ post_slug, api_token }) => await deleteRecord(post_slug, api_token),
        deleteReport: async (slug, api_token) => await deleteReportRecord(slug, api_token),
    })

    async function fetchRecord(api_token) {
        const url = "api/admin/post-reports";
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.get(url, option);
    }

    async function deleteRecord(post_slug, api_token) {
        const url = `api/admin/post-reports/${post_slug}`;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.delete(url, option);
    }

    async function deleteReportRecord(slug, api_token) {
        const url = "api/admin/post-reports/report/" + slug;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.delete(url, option);
    }

    return apis();

})()
